import API from '@/docs-partials/api';
import * as React from 'react';
export default {
  API,
  React
};